import React from 'react'
import CookieConsent from 'react-cookie-consent'
import { useTheme } from 'styled-components'
import { useIntl } from 'react-intl'

import { CookiesStyled } from '../styles/CookiesStyled'
import { BodyM } from '../styles/Typography'

import Plus from './icons/Plus'

/**
 * The Cookie banner.
 * @param {ComponentProps} props
 * @returns {FunctionComponent}
 */
const Cookies = () => {
  const theme = useTheme()
  const intl = useIntl()

  return (
    <CookiesStyled>
      <CookieConsent
        buttonText={<Plus className="icon-close" color={theme.textLight} />}
        buttonClasses="btn"
        contentClasses="content"
        cookieName="gatsby-gdpr-google-analytics"
      >
        <BodyM color={theme.textLight}>
          {intl.formatMessage({ id: 'cookies_text_1' })}{' '}
          <a href="/privacy-policy" className="link">
            {intl.formatMessage({ id: 'cookies_privacy_policy' })}
          </a>
          {intl.formatMessage({ id: 'cookies_text_2' })}
        </BodyM>
      </CookieConsent>
    </CookiesStyled>
  )
}

export default Cookies
